<template lang="html">
  <div>
    <v-container
      grid-list-lg
      py-8
      fluid
    >
      <v-layout wrap>
        <v-flex v-bind="_pageLayout">
          <v-layout wrap>
            <v-flex
              xs12
              mb-4
              class="display-2 font-weight-light"
            >
              About Super Info
            </v-flex>
            <v-flex xs12>
              <p>Founded in 2015, Super Info specializes in automating complex financial and superannuation calculations.</p>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container
      grid-list-lg
      py-8
      mb-12
      fluid
      stylexxx="background-color:#dfeeee"
    >
      <v-layout wrap>
        <v-flex v-bind="_pageLayout">
          <v-layout wrap>
            <v-flex
              xs12
              class="display-1 font-weight-light"
            >
              Our founders
            </v-flex>
            
            <v-flex mt-6>
              <v-layout wrap>
                <v-flex
                  xs12
                  sm3
                  shrink
                >
                  <v-img
                    aspect-ratio="1"
                    src="https://firebasestorage.googleapis.com/v0/b/super-info.appspot.com/o/assets%2Fdan_blackman.jpg?alt=media"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm9
                >
                  <div class="headline font-weight-light">
                    Dan Blackman
                  </div>
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</p>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex mt-6>
              <v-layout wrap>
                <v-flex
                  xs12
                  sm3
                  shrink
                >
                  <v-img
                    aspect-ratio="1"
                    src="https://firebasestorage.googleapis.com/v0/b/super-info.appspot.com/o/assets%2Fphil_klitscher.jpeg?alt=media"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm9
                >
                  <div class="headline font-weight-light">
                    Phil Klitscher
                  </div>
                  <p>Founded in 2015 Super Info </p>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import renderReady from '@/mixins/render-ready'


export default {
  mixins: [ renderReady ],
  computed: {
    ...mapGetters(['_pageLayout'])
  }
}
</script>

<style lang="css" scoped>

</style>
